import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import {
  CONDITION_FIELDS,
  conditionField,
  operator,
  operatorsForField
} from '../config/rateShopConstants';
import { conditionWord } from '../lib/describe';
import ConditionValue from './ConditionValue';
import HelpTip from './HelpTip';
import useRowKeys from '../hooks/useRowKeys';
const initialValue = (field, op) =>
  operator(op)?.value === 'many'
    ? []
    : operator(op)?.value === 'range'
    ? ['', '']
    : conditionField(field)?.type === 'bool'
    ? false
    : '';
const defaultOperator = field =>
  field === 'postalPrefix'
    ? 'starts_with'
    : ['tag', 'sku'].includes(field)
    ? 'has'
    : conditionField(field)?.type === 'number'
    ? 'gt'
    : 'eq';
const ConditionBuilder = ({
  title,
  conditions,
  onChange,
  disabled,
  tagNames,
  tagsLoading,
  stores
}) => {
  const rowKeys = useRowKeys();
  return (
    <div className="border rounded p-3 mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">{title}</h6>
        {!disabled && (
          <Button
            type="button"
            size="sm"
            variant="outline-primary"
            onClick={() =>
              onChange([
                ...conditions,
                { field: 'storeId', op: 'eq', value: '' }
              ])
            }
          >
            Add a condition
          </Button>
        )}
      </div>
      {!conditions.length && (
        <p className="small text-muted mb-0">
          No limits here — all orders qualify for this part.
        </p>
      )}
      {conditions.map((condition, index) => {
        const field = conditionField(condition.field);
        const change = patch =>
          onChange(
            conditions.map((c, i) =>
              i === index ? rowKeys.replace(c, { ...c, ...patch }) : c
            )
          );
        return (
          <div className="border-top pt-3 mt-3" key={rowKeys.key(condition)}>
            <Row className="g-2 align-items-center">
              <Col md={4}>
                <div className="d-flex align-items-center gap-2">
                  <strong>If</strong>
                  <Form.Select
                    aria-label={`${title} field ${index + 1}`}
                    value={condition.field}
                    disabled={disabled}
                    onChange={e => {
                      const field = e.target.value;
                      const op = defaultOperator(field);
                      change({ field, op, value: initialValue(field, op) });
                    }}
                  >
                    {CONDITION_FIELDS.map(f => (
                      <option key={f.id} value={f.id}>
                        {f.label}
                      </option>
                    ))}
                  </Form.Select>
                  <HelpTip label={field?.label || 'Condition'}>
                    {field?.help}
                  </HelpTip>
                </div>
              </Col>
              {field?.type !== 'bool' && (
                <Col md={3}>
                  <Form.Select
                    aria-label={`${title} comparison ${index + 1}`}
                    disabled={disabled}
                    value={condition.op}
                    onChange={e =>
                      change({
                        op: e.target.value,
                        value: initialValue(condition.field, e.target.value)
                      })
                    }
                  >
                    {operatorsForField(condition.field, condition.op).map(
                      op => (
                        <option key={op.id} value={op.id}>
                          {conditionWord(field, op.id)}
                        </option>
                      )
                    )}
                  </Form.Select>
                </Col>
              )}
              <Col md={field?.type === 'bool' ? 7 : 4}>
                <ConditionValue
                  condition={condition}
                  disabled={disabled}
                  tagNames={tagNames}
                  tagsLoading={tagsLoading}
                  stores={stores}
                  onChange={value => change({ value })}
                />
              </Col>
              <Col md={1}>
                {!disabled && (
                  <Button
                    type="button"
                    variant="outline-danger"
                    size="sm"
                    aria-label={`Remove condition ${index + 1}`}
                    onClick={() =>
                      onChange(conditions.filter((_, i) => i !== index))
                    }
                  >
                    ×
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        );
      })}
    </div>
  );
};
export default ConditionBuilder;
